export { default as BueroIcon } from './BueroIcon';
export { default as GastroIcon } from './GastroIcon';
export { default as PraxisIcon } from './PraxisIcon';
export { default as RetailIcon } from './RetailIcon';
export { default as SonstigesIcon } from './SonstigesIcon';
